import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';
import { buildImageUrl } from '../api/client';

export default function Blog() {
  const navigate = useNavigate();
  const { data: posts, loading } = usePublicList('blog');
  const sorted = [...posts].sort((a, b) => a.order - b.order);
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Bloq</h2>
        <p className="section-subtitle">Son məqalələr və xəbərlər</p>
        {loading ? <p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p> : (
          <div className="grid-3">
            {sorted.map((b) => (
              <div key={b.id} className="pcard" onClick={() => navigate(`/bloq/${b.id}`)}>
                <h5 style={{ marginBottom: 14 }}>{b.title}</h5>
                <div className="thumb"><img src={buildImageUrl(b.image)} alt={b.title} /></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
